import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCheckbox]',
})
export class CheckboxDirective {
  constructor(private elementRef: ElementRef<HTMLButtonElement>) {
    this.elementRef.nativeElement.classList.add('manteca-checkbox');
  }
}
